<section fxLayout="column" fxFlexAlign="stretch"> 
    <table>
        <tr>
           <td style="vertical-align: top;width: 30%;">
               <img src="../../assets/image-shell.png" width="100%" />
           </td> 
           <td style="vertical-align: top;padding-left: 12px;">
                <div>   
                    <h2>ΠΡΟΣΚΛΗΣΗ</h2>
                    <br/>
                    <p>Αγαπητοί συνάδελφοι,</p>
                    <br/>
                    <p>To Διοικητικό Συμβούλιο της Ελληνικής Εταιρείας Γλαυκώματος ανακοινώνει ότι το 27ο Συνέδριο Γλαυκώματος θα πραγματοποιηθεί μεταξύ 30 Μαρτίου - 1 Απριλίου 2023, στην Αθήνα.</p>
                    <p>Όπως κάθε χρόνο, η θεματολογία είναι εστιασμένη στην καθημερινή κλινική πράξη και πλαισιώνεται από έγκριτους ξένους και Έλληνες ομιλητές, που μέσα από διαλέξεις, κλινικά φροντιστήρια, συμπόσια, dry labs & στρογγυλά τραπέζια, θα μας ενημερώσουν για τις νεότερες εξελίξεις στον τομέα του Γλαυκώματος και πως η νέα γνώση μεταφράζεται και εφαρμόζεται στην καθημερινή κλινική πράξη.</p>
                    <p>Πιστεύουμε και ελπίζουμε στην ενεργό συμμετοχή σας για τη διεξαγωγή ενός επιτυχημένου συνεδρίου για μία ακόμη χρονιά.</p>
                    <p>Εκ μέρους του Δ.Σ. της Ελληνικής Εταιρείας Γλαυκώματος</p>
                    <p></p>
                    <br/>
                    <p>Ο Πρόεδρος</p>
                    <p>Φώτης Τοπούζης</p>
                    <!-- <div><img src="..\..\assets\images\terzidou.jpg" /></div> -->
                </div>
           </td>
        </tr>
    </table>
    </section>